<!--suppress ALL -->
<template>
  <v-select :items="options" v-model="model" :label="computedLabel" outlined rounded dense hide-details="auto"
  ></v-select>
</template>

<script>

import MediaType from "root/packages/closeapp/QuestionsManager/assets/types/MediaType";

export default {
  name: "media-type-select",
  props: { value: { default: null }, label: String },
  computed: {
    computedLabel() {
      return this.label ?? this.$t('pages.createQuestion.mediaType')
    },
    options() {
      return MediaType.getAsOption();
    },
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
